import { FAIL, LOADING, SUCCESS } from "./actionTypes";
// export const BASE_URL = 'http://localhost:4000/api'
export const BASE_URL = process.env.REACT_APP_WAYRIDE_BASE_URL;

// socket events
export const INIT_ADMIN_SUPPORT = 'init-admin-support';
export const ADMIN_SUPPORT = 'contact-support';
export const ADMIN_SUPPORT_STATUS = 'contact-support-status';

/**
 * Credit Transaction Status
 */
export const TRANSFER = 'TRANSFER';
export const WALLET_TOPUP = 'WALLET-TOPUP';
export const WALLET_REFUND = 'WALLET-REFUND';
export const RIDE_PAYMENT = 'RIDE-PAYMENT';
export const TRANSFER_DEDUCTION = 'TRANSFER-DEDUCTION';
export const TRANSFER_TOPUP = 'TRANSFER-TOPUP';;
export const WITHDRAWAL = 'WITHDRAWAL';
export const DRIVER_COMMISSION = 'DRIVER-COMMISSION';

export const CREDIT = 'WAYRIDE-CREDIT';
export const PROMO = 'PROMOTION';

export const getToken = () => localStorage.getItem('wayride_token');

export const getAdminDetails = () => JSON.parse(localStorage.getItem('wayride_admin'));

export const asyncIsPending = (state) => {
  state.status = LOADING;
}

export const asyncIsRejected = (state, action) => {
  console.log('rejected', action);
  state.status = FAIL;
  if (action.payload) {
    if (action.payload && action.payload.authState) {
      state.authState = action.payload.authState;
    }
    if (action.payload.message === 'Unauthorized to access this route' || action.payload.message === 'jwt expired') {
      localStorage.removeItem('wayride_token');
      localStorage.removeItem('wayride_admin');
      state.authState = 'AUTH-CHANGE';
    } else {
      state.message = action.payload.message;
    }
  } else {
    state.message = 'Operation Failed';
  }
}

export const asyncIsFulfilled = (state, action) => {
  console.log('action config', action);
  if (action.payload.authState) {
    state.authState = action.payload.authState;
  }
  state.status = SUCCESS;
  state.message = action.payload.message;
}